module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("b9aTk"))).then(() => parcelRequire('ikE14'));